var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import { YES_OR_NO_CHOICES } from '@declaration/helpers/choices';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
const claim = namespace('claim');
const qualification = namespace('qualification');
const settings = namespace('settings');
let IsRehousingNeededQuestion = class IsRehousingNeededQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.yesNoQuestionValuesAndTradKeys = YES_OR_NO_CHOICES;
    }
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    updateClaim(isPremiseFurnished) {
        this.updateAndSaveQualification({
            qualificationPayload: { isPremiseFurnished },
            step: this.step,
        });
    }
    get panelTitle() {
        return this.$tc('claim.qualification.premise-furnished.title');
    }
    get sidebarTitle() {
        const key = 'claim.qualification.premise-furnished.sidebar_title';
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get answer() {
        if (this.qualification.isPremiseFurnished === null) {
            return null;
        }
        return this.qualification.isPremiseFurnished
            ? this.$tc('claim.qualification.premise-furnished.sumup.yes')
            : this.$tc('claim.qualification.premise-furnished.sumup.no');
    }
    get hideHelpLink() {
        return insurerHasFeature(InsurerFeatureFlag.HideHelpLink);
    }
    get showHelpLink() {
        var _a, _b, _c, _d;
        if (this.hideHelpLink &&
            ((_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.isPremiseFurnished) === null || _d === void 0 ? void 0 : _d.showHelpLink) === false) {
            return false;
        }
        return true;
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], IsRehousingNeededQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], IsRehousingNeededQuestion.prototype, "qualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], IsRehousingNeededQuestion.prototype, "updateAndSaveQualification", void 0);
__decorate([
    settings.Getter('setting')
], IsRehousingNeededQuestion.prototype, "setting", void 0);
IsRehousingNeededQuestion = __decorate([
    Component({
        components: { QuestionPanel, RadioPrimaryButton },
        props: QuestionProps,
    })
], IsRehousingNeededQuestion);
export default IsRehousingNeededQuestion;
